import { render } from "./Worklist.vue?vue&type=template&id=970487c6&scoped=true"
import script from "./Worklist.vue?vue&type=script&lang=js"
export * from "./Worklist.vue?vue&type=script&lang=js"

import "./Worklist.vue?vue&type=style&index=0&id=970487c6&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970487c6"]])

export default __exports__